"use client"

import { LoadingSpinner } from "../components/LoadingSpinner"
import kieroLogo from "../media/Red_kie_ro.png"

export function LoadingPage() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-6">
      <div className="text-center w-full max-w-xs animate-fade-in">
        <div className="mb-12">
          <div className="relative mx-auto w-48 h-auto">
            <img
              src={kieroLogo}
              alt="Red Kiero"
              className="w-full h-auto object-contain drop-shadow-2xl opacity-90"
              loading="eager"
            />
          </div>
        </div>

        <div className="space-y-4">
          <LoadingSpinner size="lg" message="" />
          <p className="text-slate-400 text-sm font-medium tracking-widest uppercase animate-pulse">
            Iniciando experiencia
          </p>
        </div>
      </div>
    </div>
  )
}
